import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axiosInstance from "../utils/axiosInstance";

const REFRESH_MS = 60 * 1000;

/** Unread replies from support (support/views.py), for the menu badge. */
export default function useSupportUnread() {
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
  const [unread, setUnread] = useState(0);

  const load = useCallback(async () => {
    if (document.visibilityState === "hidden") return;
    try {
      const { data } = await axiosInstance.get("/support/unread/", { skipCompany: true });
      setUnread(Number(data?.unread) || 0);
    } catch {
      // Support not set up or unreachable: no badge, the page explains why.
      setUnread(0);
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      setUnread(0);
      return undefined;
    }
    load();
    const timer = setInterval(load, REFRESH_MS);
    window.addEventListener("support:read", load);
    return () => {
      clearInterval(timer);
      window.removeEventListener("support:read", load);
    };
  }, [isAuthenticated, load]);

  return unread;
}
